module.exports = __webpack_public_path__ + "static/img/solution_dig_bg.2722e831.png";